<template>
    <modal width="large">
        <modal-header>
            Logfile für Anfrage
        </modal-header>
        <modal-content>
            <table class="table table--stripped">
                <thead>
                <tr>
                    <th>Datum</th>
                    <th>Kunde</th>
                    <th>Produzent</th>
                    <th>Partfactory Mitarbeiter</th>
                    <th>Aktion</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="log in logbook" :key="log.index">
                    <td>{{ this.$dateTime(log.created_at) }}</td>
                    <td>{{ log?.client_user?.name }}</td>
                    <td>{{ log?.producer_user?.name }}</td>
                    <td>{{ log?.admin_user?.name }}</td>
                    <td>{{ log?.comment }}</td>
                </tr>
                </tbody>
            </table>
        </modal-content>
        <modal-actions @closeDialog="this.$emit('closeDialog')"></modal-actions>
    </modal>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
export default {
    name: 'AskForQuoteLogbook',
    components: {ModalActions, ModalContent, ModalHeader, Modal},
    props: {
        logbook: Object,
    },
    emit: ['closeDialog'],
};
</script>
